// These media queries are specific to the front teasers.

export const BreakPoints = {
  mobile: 640,
  tablet: 1174,
  desktop: 1400
}

export const mUp = `@media only screen and (min-width: ${BreakPoints.mobile}px)`
export const tUp = `@media only screen and (min-width: ${BreakPoints.tablet}px)`
export const dUp = `@media only screen and (min-width: ${BreakPoints.desktop}px)`
